import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import baseConfig from "./baseConfig.vue";
import itemConfig from "./itemConfig.vue";
import apiConfig from "./apiConfig.vue";
import { getListByID, create, update } from "@/api/config";
export default {
  components: {
    baseConfig: baseConfig,
    itemConfig: itemConfig,
    apiConfig: apiConfig
  },
  props: {
    id: {
      type: Number
    }
  },
  created: function created() {
    this.init();
  },
  data: function data() {
    return {
      tab: "first",
      config: {}
    };
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.id === 0)) {
                _context.next = 4;
                break;
              }
              _this.config = {
                formId: 0,
                title: "",
                formApi: [],
                formParam: []
              };
              _context.next = 8;
              break;
            case 4:
              _context.next = 6;
              return getListByID({
                formId: _this.id
              });
            case 6:
              res = _context.sent;
              _this.config = res.data.formConfig;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    formItemChange: function formItemChange(e) {
      this.config.formParam = e;
    },
    save: function save() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, res1;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.config.title) {
                _context2.next = 3;
                break;
              }
              _this2.$message({
                type: 'warning',
                message: "表单标题必填"
              });
              return _context2.abrupt("return");
            case 3:
              if (!(_this2.config.formId === 0)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 6;
              return create(_this2.config);
            case 6:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  message: "保存成功"
                });
                _this2.$emit("backFather", false);
              }
              _context2.next = 14;
              break;
            case 10:
              _context2.next = 12;
              return update(_this2.config);
            case 12:
              res1 = _context2.sent;
              if (res1.code === 0) {
                _this2.$message({
                  message: "更新成功"
                });
                _this2.$emit("backFather", false);
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};